import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import HeroCarousel from "./components/HeroCarousel";
import CategoryEntry from "./components/CategoryEntry";
import LatestAndHot from "./components/LatestAndHot";
import EditorPicks from "./components/EditorPicks";
import { FEATURED_FILMS, FILMS, ACTOR_TAGS, CATEGORY_META } from "@/mocks/films";

const TICKER_TAGS = [...ACTOR_TAGS.slice(0, 6), ...CATEGORY_META.map((cat) => cat.name)];

export default function Home() {
  return (
    <SiteLayout>
      <HeroCarousel films={FEATURED_FILMS} />

      <div className="w-full bg-primary-900 text-background-200 overflow-hidden border-y border-primary-800">
        <div className="w-full px-4 md:px-8">
          <div className="max-w-[1280px] mx-auto flex items-center gap-3 h-10">
            <span className="shrink-0 text-[11px] tracking-[0.2em] uppercase text-accent-400 flex items-center gap-1.5">
              <i className="ri-notification-3-line text-[12px]" />
              快讯
            </span>
            <div className="relative flex-1 overflow-hidden">
              <div className="flex items-center gap-6 whitespace-nowrap animate-marquee">
                {[0, 1].map((round) => (
                  <div key={round} className="flex items-center gap-6">
                    {TICKER_TAGS.map((tag) => (
                      <Link
                        key={`${round}-${tag}`}
                        to={`/search?q=${encodeURIComponent(tag)}`}
                        className="text-[12px] text-background-300 hover:text-accent-300 transition-colors"
                      >
                        <i className="ri-price-tag-3-line mr-1 text-[11px] text-background-500" />
                        {tag}
                      </Link>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <CategoryEntry />
      <LatestAndHot />
      <EditorPicks />

      <section className="w-full bg-primary-950 text-background-200">
        <div className="w-full px-4 md:px-8 py-12 md:py-16">
          <div className="max-w-[1280px] mx-auto grid grid-cols-1 lg:grid-cols-[1.2fr_1fr] gap-10 items-center">
            <div>
              <p className="text-[11px] tracking-[0.3em] uppercase text-accent-400 mb-2">
                About the Archive
              </p>
              <h2 className="font-heading text-2xl md:text-3xl font-semibold text-background-50 leading-snug">
                一个为影片资料而生的欧美影视档案库
              </h2>
              <p className="mt-4 text-sm md:text-[15px] leading-relaxed text-background-300">
                我们整理欧美成人影视作品的剧情梗概、演职员表、上映信息与题材标签，并按照剧情、爱情、动作、悬疑等类别建立清晰的浏览结构。你可以通过分类筛选、关键词搜索与相关推荐，高效地找到想了解的影片，并在详情页看到完整的资料与主演信息。
              </p>
              <div className="mt-6 flex flex-wrap gap-3">
                <Link
                  to="/about"
                  className="inline-flex items-center gap-2 h-10 px-5 rounded-md bg-accent-500 text-primary-950 text-sm font-semibold whitespace-nowrap hover:bg-accent-400 transition-colors cursor-pointer"
                >
                  了解网站定位
                  <i className="ri-arrow-right-line text-[13px]" />
                </Link>
                <Link
                  to="/category/literary"
                  className="inline-flex items-center gap-2 h-10 px-5 rounded-md border border-background-50/25 text-background-100 text-sm whitespace-nowrap hover:bg-background-50/10 transition-colors cursor-pointer"
                >
                  浏览文艺片分类
                </Link>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-3 md:gap-4">
              {[
                { value: `${FILMS.length}`, label: "收录影片资料", icon: "ri-film-line" },
                { value: `${CATEGORY_META.length}`, label: "题材分类入口", icon: "ri-layout-grid-line" },
                { value: `${ACTOR_TAGS.length}`, label: "演员档案标签", icon: "ri-user-star-line" },
                { value: "100%", label: "资料与详情一致", icon: "ri-check-double-line" },
              ].map((item) => (
                <div
                  key={item.label}
                  className="rounded-lg bg-primary-900 border border-primary-800 p-4 md:p-5"
                >
                  <span className="w-9 h-9 rounded-md bg-accent-500/15 text-accent-400 flex items-center justify-center">
                    <i className={item.icon} />
                  </span>
                  <p className="mt-3 font-heading text-2xl font-semibold text-background-50">
                    {item.value}
                  </p>
                  <p className="mt-1 text-[12px] text-background-400">{item.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}